(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sl-cart-regalo"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('.slcr');
  if(!root) return;
  var steps=JSON.parse(root.querySelector('[data-slcr-steps]').textContent);
  var tx=JSON.parse(root.querySelector('[data-slcr-tx]').textContent);
  var top=steps[steps.length-1].monto;
  var fmt=function(n){return '$'+Math.round(n).toLocaleString('es-MX');};
  var last=null;
  function render(total){
    if(total===last) return; last=total;
    var cur=null,next=null;
    steps.forEach(function(s){ if(total>=s.monto) cur=s; else if(!next) next=s; });
    var msg=root.querySelector('[data-slcr-msg]'), have=root.querySelector('[data-slcr-have]');
    if(next){ msg.textContent=tx.tx_faltan.replace('[monto]',fmt(next.monto-total)).replace('[regalo]',next.regalo); }
    else { msg.textContent=tx.tx_tope.replace('[regalo]',cur?cur.regalo:''); }
    if(cur){ have.textContent=tx.tx_tienes.replace('[regalo]',cur.regalo); have.hidden=false; } else { have.hidden=true; }
    var seg=100/steps.length, pct=0, prev=0, prevPos=0;
    for(var i=0;i<steps.length;i++){ var m=steps[i].monto, pos=(i+0.5)*seg; if(total>=m){ pct=(i===steps.length-1)?100:pos; prev=m; prevPos=pos; continue; } pct=prevPos+(m>prev?(total-prev)/(m-prev)*(pos-prevPos):0); break; }
    pct=Math.max(0,Math.min(100,pct));
    root.querySelector('[data-slcr-fill]').style.width=pct+'%';
    root.querySelectorAll('[data-slcr-tick]').forEach(function(t){ t.classList.toggle('is-on', total>=parseInt(t.getAttribute('data-monto'),10)); });
  }
  function poll(){
    fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){ var t=0; (c.items||[]).forEach(function(i){ if(i.properties&&i.properties._regalo) return; if(/Sables de luz/.test(i.product_type||'')) t+=i.final_line_price; }); render(t/100); }).catch(function(){});
  }
  document.addEventListener('cart:updated',poll);
  document.addEventListener('ajaxProduct:added',poll);
  document.addEventListener('change',function(e){ if(e.target&&e.target.closest&&e.target.closest('form[action*="/cart"]')) setTimeout(poll,900); });
  document.addEventListener('click',function(e){ if(e.target&&e.target.closest&&e.target.closest('form[action*="/cart"] button, form[action*="/cart"] a')) setTimeout(poll,1200); });
  setInterval(poll,4000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-etl-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  var save=navigator.connection&&navigator.connection.saveData;
  if(save) return;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce) return;
  function sync(){
    document.querySelectorAll('.etlhero video[data-etl-video]').forEach(function(v){
      var visible=getComputedStyle(v).display!=='none';
      if(visible){ if(v.preload==='none'){v.preload='auto';v.load();} var p=v.play(); if(p&&p.catch){p.catch(function(){});} }
      else if(!v.paused){ v.pause(); }
    });
  }
  sync();
  var t; window.addEventListener('resize',function(){clearTimeout(t);t=setTimeout(sync,250);});
  document.addEventListener('shopify:section:load',sync);
})();
(function(){
  if (window.__etlCountdown) return; window.__etlCountdown = true;
  var DIA = 86400000;
  function pad(n){ return (n<10?'0':'')+n; }
  function num(el, attr, def){ var v = parseFloat(el.getAttribute(attr)); return isNaN(v) ? def : v; }
  function tick(){
    var ahora = Date.now() + (window.__etlOffset || 0);
    document.querySelectorAll('[data-etl-countdown]').forEach(function(el){
      var end = Date.parse(el.getAttribute('data-etl-countdown')); if (isNaN(end)) return;
      var diff = end - ahora;
      if (diff <= 0) { if (el.hidden) el.hidden = false; if (!el.classList.contains('is-over')) { el.classList.add('is-over'); el.textContent = el.getAttribute('data-etl-over') || ''; } return; }
      var d = Math.floor(diff/DIA), h = Math.floor(diff%DIA/3600000), m = Math.floor(diff%3600000/60000), s = Math.floor(diff%60000/1000);
      if (d > num(el, 'data-etl-mostrar', 10)) { if (!el.hidden) el.hidden = true; return; }
      if (el.hidden) el.hidden = false;
      var soloDias = diff > num(el, 'data-etl-reloj', 5) * DIA;
      el.classList.toggle('is-dias', soloDias);
      var set = function(sel, v){ var n = el.querySelector(sel); if (n && n.textContent !== String(v)) n.textContent = v; };
      set('[data-etl-d]', d); set('[data-etl-h]', pad(h)); set('[data-etl-m]', pad(m)); set('[data-etl-s]', pad(s));
    });
  }
  window.__etlTick = tick;
  tick(); setInterval(tick, 1000);
})();

  } catch(e) { console.error(e); }
})();
})();
